// src/pages/commercial/CommercialMapPage.js
// Dependencies: react-leaflet, leaflet
import React, { useEffect, useState } from 'react';
import CommercialLayout from '../../components/commercial/CommercialLayout';
import { useAuth } from '../../contexts/AuthContext';
import pb from '../../lib/pocketbase';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix generic marker icon issue in React Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default function CommercialMapPage() {
    const { user } = useAuth();
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);

    // Default center (Paris)
    const center = [48.8566, 2.3522];

    const fetchClients = async () => {
        setLoading(true);
        try {
            // We fetch clients. In a real scenario, we need lat/lng.
            // Here we will simulate random positions around Paris IF no lat/lng exists to demonstrate the UI.
            // In prod, you must Geocode addresses.
            const res = await pb.collection('customers').getFullList({
                sort: '-created'
            });

            // Mocking positions for demo if fields missing
            const clientsWithPos = res.map((c, i) => {
                if (c.lat && c.lng) return c;

                // Random drift from Paris center for demo
                const lat = 48.8566 + (Math.random() - 0.5) * 0.1;
                const lng = 2.3522 + (Math.random() - 0.5) * 0.1;

                return { ...c, lat, lng, mock: true };
            });

            setClients(clientsWithPos);
        } catch (err) {
            console.error("Error fetching clients", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClients();
    }, []);

    return (
        <CommercialLayout title="Carte Prospects">
            <div className="commercial-page-wrapper" style={{ height: 'calc(100vh - 100px)', display: 'flex', flexDirection: 'column' }}>
                <style>{`
                .commercial-page-wrapper {
                    --admin-panel: var(--commercial-panel, #fff);
                    --admin-panel-2: var(--commercial-panel-2, #f9fafb);
                    --admin-border: var(--commercial-border, #e2e8f0);
                    --admin-text: var(--commercial-text, #0f172a);
                    --admin-muted: var(--commercial-muted, #64748b);
                    --admin-accent: var(--commercial-accent, #4f46e5);
                }
                .leaflet-container {
                     width: 100%; height: 100%; border-radius: 12px;
                     z-index: 1;
                }
                .map-header {
                    margin-bottom: 16px; 
                    display: flex; justify-content: space-between; align-items: center;
                }
                `}</style>

                <div className="map-header">
                    <div>
                        <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Carte Clients</h1>
                        <p style={{ color: 'var(--admin-muted)', margin: 0, fontSize: '0.9rem' }}>
                            {clients.length} clients localisés (Simulation)
                        </p>
                    </div>
                </div>

                <div style={{ flex: 1, border: '1px solid var(--admin-border)', borderRadius: 12, overflow: 'hidden' }}>
                    {loading ? (
                        <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>Chargement de la carte...</div>
                    ) : (
                        <MapContainer center={center} zoom={12} scrollWheelZoom={true}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {clients.map(client => (
                                <Marker key={client.id} position={[client.lat, client.lng]}>
                                    <Popup>
                                        <div style={{ fontSize: '1rem', fontWeight: 'bold' }}>{client.name}</div>
                                        <div>{client.company}</div>
                                        <div style={{ fontSize: '0.85rem', color: '#666' }}>{client.email}</div>
                                        <div style={{ marginTop: 8 }}>
                                            <a href={`/commercial/clients`} style={{ color: 'var(--admin-accent)' }}>Voir fiche</a>
                                        </div>
                                    </Popup>
                                </Marker>
                            ))}
                        </MapContainer>
                    )}
                </div>
            </div>
        </CommercialLayout>
    );
}
